import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function clientnde() {
  return (
    <section className="client_nde p-100 text_nde">
      <Container>
        <Row>
          <Col
            xs={12}
            md={5}
            lg={5}
            xl={5}
            xxl={5}
            className="text-center resp_order"
          >
            <div className="client_img_nde">
              <StaticImage
                src="../../../images/case-studies/nde/client.webp"
                alt="TekRevol"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={589}
                height={608}
              />
            </div>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="offset-xl-1 offset-lg-1 my-auto"
          >
            <h2>The Client had?</h2>
            <p>
              The client had an outdated website and web portals that required a
              quick code revamp and maintenance.
            </p>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default clientnde;
